import React, { useEffect } from "react";
import styled from "styled-components";
import { emptyApplication } from "./emptyApplication";
import TopBannerMessageNotifyForm from "./TopBannerMessageNotifyForm";


export const ApplicationTitleLabel = styled.div`
  font-size: 18px;
  text-decoration: none;
  color: black;
  font-weight: 500;
`;

const TopBannerMessagePageModal = ({
  open,
  cancel,
  title,
  application = emptyApplication,
  applications,
  refetch
}) => {
  const [applicationForm, setApplicationForm] = React.useState({
    ...application
  });
 

  useEffect(() => {
    if (application) {
      setApplicationForm({
        ...application
      });
    } else {
      setApplicationForm({
        ...emptyApplication
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [application]);
  return (
      <TopBannerMessageNotifyForm
            isApplicationNull={application === null}
            applications={applications}
            application={applicationForm}
            open={open}
            cancel={cancel}
            title={title}
            refetch={refetch}
      />
  );
};

export default TopBannerMessagePageModal;